export default __webpack_public_path__ + "static/media/maduro4.cf5a5495.png";